/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateEnumerationQuantityUsageDto } from './CreateEnumerationQuantityUsageDto';
import {
    CreateEnumerationQuantityUsageDtoFromJSON,
    CreateEnumerationQuantityUsageDtoFromJSONTyped,
    CreateEnumerationQuantityUsageDtoToJSON,
} from './CreateEnumerationQuantityUsageDto';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { QuantityUsageType } from './QuantityUsageType';
import {
    QuantityUsageTypeFromJSON,
    QuantityUsageTypeFromJSONTyped,
    QuantityUsageTypeToJSON,
} from './QuantityUsageType';
import type { StateOfUse } from './StateOfUse';
import {
    StateOfUseFromJSON,
    StateOfUseFromJSONTyped,
    StateOfUseToJSON,
} from './StateOfUse';

/**
 * 
 * @export
 * @interface CreateUpdateEnumerationQuantityDto
 */
export interface CreateUpdateEnumerationQuantityDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateEnumerationQuantityDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateEnumerationQuantityDto
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateEnumerationQuantityDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {StateOfUse}
     * @memberof CreateUpdateEnumerationQuantityDto
     */
    state?: StateOfUse;
    /**
     * 
     * @type {QuantityUsageType}
     * @memberof CreateUpdateEnumerationQuantityDto
     */
    quantityUsageType?: QuantityUsageType;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof CreateUpdateEnumerationQuantityDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {CreateEnumerationQuantityUsageDto}
     * @memberof CreateUpdateEnumerationQuantityDto
     */
    setupUsage?: CreateEnumerationQuantityUsageDto;
    /**
     * 
     * @type {CreateEnumerationQuantityUsageDto}
     * @memberof CreateUpdateEnumerationQuantityDto
     */
    evaluationUsage?: CreateEnumerationQuantityUsageDto;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateEnumerationQuantityDto
     */
    $type?: CreateUpdateEnumerationQuantityDtoTypeEnum;
}


/**
 * @export
 */
export const CreateUpdateEnumerationQuantityDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoEnumerationDtoCreateUpdateEnumerationQuantityDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.EnumerationDto.CreateUpdateEnumerationQuantityDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateUpdateEnumerationQuantityDtoTypeEnum = typeof CreateUpdateEnumerationQuantityDtoTypeEnum[keyof typeof CreateUpdateEnumerationQuantityDtoTypeEnum];


/**
 * Check if a given object implements the CreateUpdateEnumerationQuantityDto interface.
 */
export function instanceOfCreateUpdateEnumerationQuantityDto(value?: unknown): value is CreateUpdateEnumerationQuantityDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateUpdateEnumerationQuantityDtoTypeEnum)[0];
}

export function CreateUpdateEnumerationQuantityDtoFromJSON(json: any): CreateUpdateEnumerationQuantityDto {
    return CreateUpdateEnumerationQuantityDtoFromJSONTyped(json, false);
}

export function CreateUpdateEnumerationQuantityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateEnumerationQuantityDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'isAvailable': !exists(json, 'isAvailable') ? undefined : json['isAvailable'],
        'state': !exists(json, 'state') ? undefined : StateOfUseFromJSON(json['state']),
        'quantityUsageType': !exists(json, 'quantityUsageType') ? undefined : QuantityUsageTypeFromJSON(json['quantityUsageType']),
        'attachments': !exists(json, 'attachments') ? undefined : (json['attachments'] === null ? null : (json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'setupUsage': !exists(json, 'setupUsage') ? undefined : CreateEnumerationQuantityUsageDtoFromJSON(json['setupUsage']),
        'evaluationUsage': !exists(json, 'evaluationUsage') ? undefined : CreateEnumerationQuantityUsageDtoFromJSON(json['evaluationUsage']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function CreateUpdateEnumerationQuantityDtoToJSON(value?: CreateUpdateEnumerationQuantityDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'name': value.name,
        'description': value.description,
        'isAvailable': value.isAvailable,
        'state': StateOfUseToJSON(value.state),
        'quantityUsageType': QuantityUsageTypeToJSON(value.quantityUsageType),
        'attachments': value.attachments === undefined ? undefined : (value.attachments === null ? null : (value.attachments as Array<any>).map(FileMetaInfoDtoToJSON)),
        'setupUsage': CreateEnumerationQuantityUsageDtoToJSON(value.setupUsage),
        'evaluationUsage': CreateEnumerationQuantityUsageDtoToJSON(value.evaluationUsage),
        '$type': value.$type,
    });
}

